import Checkout from './checkout';
import CashbackEarnedModal from './CashbackEarnedModal';
import CompanyDetailsModal from './CompanyDetailsModal';
import MenuItemsModal from './MenuItemsModal';
import MultiPromoCodeModal from './MultiPromoCodeModal';
import OrderMethod from './order-method';
import OtpVerificationModal from './OtpVerificationModal';
import LoginModal from './LoginModal';
import RewardsUnlockedModal from './RewardsUnlockedModal';
import PointsEarnedModal from './PointsEarnedModal';
import FreeProductsModal from './FreeProductsModal';
import MenuItemModal from './MenuItemModal';

export default {
  Checkout,
  CashbackEarnedModal,
  CompanyDetailsModal,
  MenuItemsModal,
  MultiPromoCodeModal,
  OrderMethod,
  OtpVerificationModal,
  LoginModal,
  RewardsUnlockedModal,
  PointsEarnedModal,
  FreeProductsModal,
  MenuItemModal,
};
